import React, { FunctionComponent } from "react";
import Button from "@material-ui/core/Button";
import { Grid } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useState } from "react";

type ItemCartonDialogProps = {
  openCustomerSelectDialog: boolean;
  //   cartonFlag: boolean;
  //   cartonData: any;
  onCancel: () => void;
  onSelectCustomer: (customer: string) => void;
  setCustomer_type: (type: string) => void;
  customer_type: string;
};
export const CustomerSelectDialog: FunctionComponent<ItemCartonDialogProps> = ({
  openCustomerSelectDialog,
  onCancel,
  onSelectCustomer,
  setCustomer_type,
  customer_type,
}) => {
  return (
    <Dialog
      open={openCustomerSelectDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <div>
          <DialogTitle id="simple-dialog-title">
            Please select customer type
          </DialogTitle>

          <Grid container style={{ padding: "1em" }}>
            <Grid item>
              <RadioGroup
                aria-label="position"
                row
                name="customer_type"
                onChange={(event: any) => {
                  setCustomer_type(event.target.value);

                  //setValue(event.target.value);
                }}
                value={customer_type}
              >
                <FormControlLabel
                  value="C"
                  control={<Radio color="primary" />}
                  label="Normal customer"
                  labelPlacement="end"
                />
                <FormControlLabel
                  value="R"
                  control={<Radio color="primary" />}
                  label="Credit customer"
                  labelPlacement="end"
                />
              </RadioGroup>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onSelectCustomer(customer_type);
          }}
          id="buton"
        >
          Submit
        </Button>
        <Button
          onClick={() => {
            onCancel();
          }}
          autoFocus
          id="buton"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
